import { useState, useEffect, useCallback } from 'react';
import { productService } from '../services/productService';
import { mockProducts } from '../data/mockProducts';

export function useProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      // First time, seed with mock data if sheet is empty
      await productService.seed(mockProducts);
      const data = await productService.getAll();
      setProducts(data);
      setIsConnected(true);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch products:', err);
      setError(err.message);
      setIsConnected(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { products, loading, error, isConnected, refresh: fetchProducts };
}